import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2 } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostPassiveAggressiveTextsID() {
  const articleData = {
    title: 'Panduan Utama Teks Pasif-Agresif',
    description: 'Bingung dengan teks yang membuat Anda frustrasi atau kesal? Pelajari cara mengenali pesan pasif-agresif dengan deteksi bertenaga AI dari Toxic Detector.',
    slug: 'ultimate-guide-passive-aggressive-texts',
    publishDate: '2025-05-22',
    author: 'Editorial Toxic Detector'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'Apa itu teks pasif-agresif?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Teks yang menyampaikan permusuhan, kritik, atau frustrasi secara tidak langsung, seringkali membuat penerima bingung atau kesal.'
      }
    }, {
      '@type': 'Question',
      name: 'Mengapa orang mengirim pesan pasif-agresif?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ini sering kali merupakan cara terselubung untuk mengekspresikan kemarahan, membuat rasa bersalah, atau memanipulasi tanpa konfrontasi terbuka.'
      }
    }, {
      '@type': 'Question',
      name: 'Bisakah AI mendeteksi perilaku pasif-agresif dalam pesan?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ya. Toxic Detector menganalisis nada, frasa, penggunaan emoji, pola respons, dan sarkasme halus untuk menandai teks manipulatif.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sJh1uV1DahBAgXTJX4idSp/1763121685117.jpg',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    datePublished: articleData.publishDate,
    url: `https://toxicdetector.com/id/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText('https://toxicdetector.com/');
      alert('Tautan disalin ke papan klip!');
    }
  };
  return <>
      <MetaTags title="Panduan Utama Teks Pasif-Agresif — Bagaimana AI Mendeteksi Manipulasi | ToxicDetector" description="Bingung dengan teks yang membuat Anda frustrasi? Pelajari cara mengenali pesan pasif-agresif dengan AI." keywords="teks pasif-agresif, perilaku pasif-agresif terselubung, pola manipulasi teks, detektor agresi pasif AI" canonical={`https://toxicdetector.com/id/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/rgRp5kcuKrQdAWFQxfbcKt/file_0000000085487243beb3c848ebc5ef15.png" schema={[faqSchema, articleSchema]} data-id="element-6879" data-mp="vbwqx20ziq14" />
      <div className="flex flex-col w-full min-h-screen bg-[#fafaf9]" data-id="element-6880" data-mp="3dmaxqkbon41e">
        <header className="bg-white border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm bg-white/95" data-id="element-6881" data-mp="38u13wt7g5jtu">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-6882" data-mp="3ninrtjb53jwo">
            <div className="flex items-center justify-between" data-id="element-6883" data-mp="3nl9zdiy15zew">
              <Link to="/" className="text-2xl font-bold tracking-tight" data-id="element-6884" data-mp="3ijkpw7qghtsx">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Bagikan artikel" data-id="element-6885" data-mp="cn11c0yfvq0">
                <Share2 size={20} data-id="element-6886" data-mp="227xho1n67svx" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-12" data-id="element-6887" data-mp="1y6vc732nukli">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors" data-id="element-6888" data-mp="1zl66sqjeiwar">
            <ArrowLeft size={16} className="mr-2" data-id="element-6889" data-mp="28m4epjwynnym" />
            Kembali ke Beranda
          </Link>

          <header className="mb-12" data-id="element-6890" data-mp="2dlpdnuc4rwbc">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-6891" data-mp="2dko2zqz11bu5">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-6892" data-mp="1kwif4vcof6q3">
              <time dateTime={articleData.publishDate} data-id="element-6893" data-mp="1kuffrkpmw18p">
                {new Date(articleData.publishDate).toLocaleDateString('id-ID', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-6894" data-mp="x6xmtlumux45">•</span>
              <span data-id="element-6895" data-mp="125im9j229crj">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-6896" data-mp="umj2hcaotj7n">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sJh1uV1DahBAgXTJX4idSp/1763121685117.jpg" alt="AI menganalisis pesan teks pasif-agresif" className="w-full rounded-2xl shadow-lg" data-id="element-6897" data-mp="ulgebc4r1uvf" />
          </div>

          <div className="bg-white rounded-2xl p-7 border border-gray-200 mb-12" data-id="element-6898" data-mp="gnjgkcek7if6">
            <h2 className="font-bold text-lg mb-5" data-id="element-6899" data-mp="bnx4w7edqa8h">Daftar Isi</h2>
            <ol className="space-y-3 text-sm list-decimal list-inside" data-id="element-6900" data-mp="bp8742s6f9xh">
              <li data-id="element-6901" data-mp="6w5im929aqo5">
                <a href="#sure-whatever" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-6902" data-mp="6vvtsosy6pk1">
                  Klasik "Tentu, Terserah"
                </a>
              </li>
              <li data-id="element-6903" data-mp="3p2jy4cg6b8on">
                <a href="#backhanded-compliment" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-6904" data-mp="3p333kton04ls">
                  Pujian Tidak Tulus
                </a>
              </li>
              <li data-id="element-6905" data-mp="3aetd1c7a4qma">
                <a href="#friendly-reminder" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-6906" data-mp="3aih66a8tbb0h">
                  "Pengingat Ramah" yang Sebenarnya Sindiran
                </a>
              </li>
              <li data-id="element-6907" data-mp="35ht8x6tzpxxt">
                <a href="#ghostly-reply" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-6908" data-mp="35j48svkbeljn">
                  Balasan Hantu
                </a>
              </li>
              <li data-id="element-6909" data-mp="3jh2llwizm9x1">
                <a href="#sarcasm-humor" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-6910" data-mp="3jhkqfhjptwgk">
                  Sarkasme yang Disamarkan sebagai Humor
                </a>
              </li>
              <li data-id="element-6911" data-mp="fxzke2smzq0c">
                <a href="#conditional-niceness" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-6912" data-mp="kqsoqpk70wbw">
                  Kebaikan Bersyarat
                </a>
              </li>
              <li data-id="element-6913" data-mp="20h1w0xcfmxo3">
                <a href="#rollercoaster" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-6914" data-mp="20huwxhopmsyb">
                  Rollercoaster Bolak-Balik
                </a>
              </li>
            </ol>
          </div>

          <div className="prose prose-lg prose-gray max-w-none" data-id="element-6915" data-mp="1mjdbxrq6vuk3">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-6916" data-mp="1hjim7ri5hb0m">
              Pernah menerima teks yang membuat Anda mempertanyakan apakah Anda
              bereaksi berlebihan — meskipun itu membuat Anda kesal, frustrasi,
              atau bingung? Itu adalah <strong data-id="element-6917" data-mp="1qidwbeobf597">teks pasif-agresif</strong> yang
              sedang beraksi.
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-6918" data-mp="36wm6e9rwfm3y">
              <strong data-id="element-6919" data-mp="31y2hc0i0du7d">Deteksi AI</strong> kami dapat menangkap pola{' '}
              <strong data-id="element-6920" data-mp="3m1gt4hv8u747">perilaku manipulatif</strong> ini secara instan. Berikut
              adalah panduan utama Anda.
            </p>

            <section id="sure-whatever" className="mb-12" data-id="element-6921" data-mp="3r134smvfbfaw">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-6922" data-mp="3v257jdoju9hm">
                1️⃣ Klasik "Tentu, Terserah"
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-6923" data-mp="3o94cqp57d5x">
                <p className="italic text-gray-700 text-lg" data-id="element-6924" data-mp="8l928ebu99ly">
                  "Tentu, apa pun yang membuatmu bahagia..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6925" data-mp="iki2tq17lmha">
                Sekilas, ini tampak setuju—tetapi di bawahnya? Penolakan atau
                sarkasme. AI menandai frasa ini.
              </p>
            </section>

            <section id="backhanded-compliment" className="mb-12" data-id="element-6926" data-mp="2kcwjkls0okw4">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-6927" data-mp="2odgcfd5k52cg">
                2️⃣ Pujian Tidak Tulus
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-6928" data-mp="2gu79a1nn9zvu">
                <p className="italic text-gray-700 text-lg" data-id="element-6929" data-mp="2c2yvktfa7scv">
                  "Wow, kamu benar-benar melakukan itu... bagus untukmu."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6930" data-mp="232ixy0l7zffx">
                Terdengar bagus? Tidak juga. Sindiran terselubung seperti ini
                merusak kepercayaan diri Anda.
              </p>
            </section>

            <section id="friendly-reminder" className="mb-12" data-id="element-6931" data-mp="2uurq4sa01lmp">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-6932" data-mp="2qs3ekctwi0m1">
                3️⃣ "Pengingat Ramah" yang Sebenarnya Sindiran
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-6933" data-mp="2ls8r6j9c3t5q">
                <p className="italic text-gray-700 text-lg" data-id="element-6934" data-mp="1fdpwjoltwfdx">
                  "Hanya supaya kamu tahu... aku membersihkan seluruh dapur."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6935" data-mp="34oo3nvkbyge">
                Teks pasif-agresif sering menyamarkan kritik sebagai info yang
                bermanfaat.
              </p>
            </section>

            <section id="ghostly-reply" className="mb-12" data-id="element-6936" data-mp="byti2g5ztq05">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-6937" data-mp="7733fy00wg2x">
                4️⃣ Balasan Hantu
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-6938" data-mp="lv6ehlsxahyl">
                <p className="italic text-gray-700 text-lg" data-id="element-6939" data-mp="gxeb9vmtv9f3">
                  "K..." atau tidak ada balasan sama sekali
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6940" data-mp="uujlm7tkqug5">
                Respons singkat, tertunda, atau hilang dapat menghukum tanpa
                konfrontasi.
              </p>
            </section>

            <section id="sarcasm-humor" className="mb-12" data-id="element-6941" data-mp="2smfa58ekuks9">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-6942" data-mp="2so05h08pu7r6">
                5️⃣ Sarkasme yang Disamarkan sebagai Humor
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-6943" data-mp="2mju7ohwaz7il">
                <p className="italic text-gray-700 text-lg" data-id="element-6944" data-mp="28sp1sy2cdizt">
                  "Oh, kamu sangat pintar 😏"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6945" data-mp="2dqh3ukwpalhq">
                Sarkasme terselubung adalah alat utama. AI kami menangkap
                konteksnya.
              </p>
            </section>

            <section id="conditional-niceness" className="mb-12" data-id="element-6946" data-mp="23v5n5x1qf47c">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-6947" data-mp="1pul5x5bgtgfy">
                6️⃣ Kebaikan Bersyarat
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-6948" data-mp="1utfxowreufc7">
                <p className="italic text-gray-700 text-lg" data-id="element-6949" data-mp="3k95lj3kxilsh">
                  "Aku akan membantu... jika aku tidak punya rencana."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6950" data-mp="3mss9i03gdxxn">
                Orang pasif-agresif menetapkan batasan untuk membuat rasa
                bersalah.
              </p>
            </section>

            <section id="rollercoaster" className="mb-12" data-id="element-6951" data-mp="3dqsqx3csilsl">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-6952" data-mp="3dtf4bjmd3viq">
                7️⃣ Rollercoaster Bolak-Balik
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-6953" data-mp="ab556dk0zcxu">
                <p className="italic text-gray-700 text-lg" data-id="element-6954" data-mp="5b91ygj5jpjc">
                  Tinggi dan rendah yang ekstrem dalam teks
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6955" data-mp="izfxbl5r9mc">
                Nada yang berfluktuasi adalah tanda bahaya untuk perilaku
                manipulatif.
              </p>
            </section>

            <section className="mb-12" data-id="element-6956" data-mp="oamxv40fzach">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-6957" data-mp="o9ll8v3s2fsn">
                🛡 Cara Melindungi Diri Sendiri
              </h2>
              <ul className="space-y-4 text-lg text-gray-600" data-id="element-6958" data-mp="vnvxbpde8kbv">
                <li className="flex items-start gap-3" data-id="element-6959" data-mp="10lxeg4r9e9kp">
                  <span className="text-gray-900 font-bold" data-id="element-6960" data-mp="15jyz2u4c2gya">•</span>
                  <span data-id="element-6961" data-mp="15insynnf0x40">Percayai insting Anda.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-6962" data-mp="1ak3d8dhrqzlc">
                  <span className="text-gray-900 font-bold" data-id="element-6963" data-mp="1eknb5ja6278j">•</span>
                  <span data-id="element-6964" data-mp="1ekdmbz0uy64f">Simpan tangkapan layar.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-6965" data-mp="1jioxcd2w2mo8">
                  <span className="text-gray-900 font-bold" data-id="element-6966" data-mp="1oaglkgykogb7">•</span>
                  <span data-id="element-6967" data-mp="1ob8hxtzzui2j">Hindari menganalisis teks secara berlebihan.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-6968" data-mp="1t8rwkv0lswv0">
                  <span className="text-gray-900 font-bold" data-id="element-6969" data-mp="1y9fmfdd3j7nn">•</span>
                  <span data-id="element-6970" data-mp="1y6tidnpezaa6">Gunakan Toxic Detector.</span>
                </li>
              </ul>
            </section>

            <section className="mb-16" data-id="element-6971" data-mp="2zyuq27wiqg16">
              <h2 className="text-3xl font-bold mb-8 tracking-tight" data-id="element-6972" data-mp="2zxtabq4k55d4">
                Pertanyaan yang Sering Diajukan
              </h2>
              <div className="space-y-6" data-id="element-6973" data-mp="2uy6xviwjzt5d">
                {faqSchema.mainEntity.map((faq, index) => <div key={index} className="bg-white rounded-xl p-6 border border-gray-200" data-id="element-6974" data-mp="34pt6r8lf5g4y" data-mpi={index}>
                    <h3 className="font-bold text-lg mb-3 text-gray-900" data-id="element-6975" data-mp="2h11ll168xy1o">
                      {faq.name}
                    </h3>
                    <p className="text-gray-600 leading-relaxed" data-id="element-6976" data-mp="2c38dg2ldutyr">
                      {faq.acceptedAnswer.text}
                    </p>
                  </div>)}
              </div>
            </section>
          </div>

          <div className="bg-gray-900 rounded-2xl p-12 text-center text-white mt-16" data-id="element-6977" data-mp="5a69yxddq0vi">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-6978" data-mp="bv0wouwruec">
              💀 Berhenti Menerjemahkan. Mulai Mengetahui.
            </h2>
            <p className="text-gray-300 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-6979" data-mp="8rtxwgvaccyr">
              Berhenti menebak. Unggah teks Anda ke Toxic Detector dan dapatkan
              skor toksisitas instan.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-6980" data-mp="3v1y0f5a8b4i6">
              <p className="font-bold text-xl" data-id="element-6981" data-mp="3vmv2wy6rhl1">
                "🚩 65% agresi pasif terdeteksi — perilaku meremehkan berulang
                ditemukan!"
              </p>
            </div>
            <Link to="/upload" className="inline-block bg-white text-gray-900 px-10 py-4 rounded-xl font-bold text-lg hover:bg-gray-100 transition-colors" data-id="element-6982" data-mp="whej76ewvmb7">
              Pindai Obrolan Anda Sekarang →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: 'Apakah Mantan Anda Narsisis Terselubung?',
          description: 'Temukan jika mantan Anda menunjukkan tanda-tanda perilaku narsisis terselubung dalam teks.',
          slug: 'is-your-ex-a-covert-narcissist',
          emoji: '🎭'
        }, {
          title: 'Pelajari Tentang Istilah: Narsisme & Gaslighting',
          description: 'Pahami pola narsisme dan gaslighting dalam hubungan.',
          slug: 'narcissism-gaslighting-explained',
          emoji: '💀'
        }]} data-id="element-6983" data-mp="1ah794zim5yi4" />

          <div className="mt-12 text-center" data-id="element-6984" data-mp="11ebncbt8p2c2">
            <button onClick={handleShare} className="inline-flex items-center text-gray-700 hover:text-gray-900 font-medium transition-colors" data-id="element-6985" data-mp="wg0cpyv4enss">
              <Share2 size={18} className="mr-2" data-id="element-6986" data-mp="rf2u5l677rqr" />
              Bagikan artikel ini
            </button>
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-12 mt-16" data-id="element-6987" data-mp="ifzaog34dabq">
          <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-6988" data-mp="iiljsk5nrxw2">
            <p className="text-gray-400 text-sm" data-id="element-6989" data-mp="2u32sxqro6330">
              © {new Date().getFullYear()} ToxicDetector. Hak cipta dilindungi
              undang-undang.
            </p>
          </div>
        </footer>
      </div>
    </>;
}